const Transactions = () => import("./views/Transactions.vue");

const CurrentUserTransactions = () => import("./views/CurrentUserTransactions.vue");
const UsersTransactions = () => import("./views/UsersTransactions.vue");
const PayuPaid = () => import("./views/PayuPaid.vue");
const Deposits = () => import("./views/Deposits.vue");
const Charges = () => import("./views/Charges.vue");
const MonthlyBalanceReport = () => import("./views/MonthlyBalanceReport.vue");
const RefundReport = () => import("./views/RefundReport.vue");
const ImportedPaymentsFiles = () => import("./views/ImportedPaymentsFiles.vue");
const ImportedPaymentsFile = () => import("./views/ImportedPaymentsFile.vue");
const BulkIncreaseBalances = () => import("./views/BulkIncreaseBalances.vue");

export default [
  {
    path: "/transactions",
    name: "transactions",
    component: Transactions,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: "/billing",
    name: "parent.billing",
    component: CurrentUserTransactions,

    meta: {
      roles: ["ROLE_PARENT", "ROLE_INSTITUTION_WORKER"],
    },
  },

  {
    path: "/usersTransactions",
    name: "transactions.usersTransactions",
    component: UsersTransactions,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },

  {
    path: "/deposits",
    name: "transactions.deposits",
    component: Deposits,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: "/charges",
    name: "transactions.charges",
    component: Charges,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: "/monthlyBalanceReport",
    name: "transactions.monthlyBalanceReport",
    component: MonthlyBalanceReport,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: "/refundReport",
    name: "transactions.refundReport",
    component: RefundReport,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: "/importedPaymentsFiles",
    name: "transactions.importedPaymentsFiles",
    component: ImportedPaymentsFiles,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: "/importedPaymentsFiles/:importedPaymentsFileId",
    name: "transactions.importedPaymentsFile",
    component: ImportedPaymentsFile,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: "/payu/paid",
    name: "payu.paid",
    component: PayuPaid,
  },

  {
    path: "/bulkIncreaseBalances",
    name: "transactions.bulkIncreaseBalances",
    component: BulkIncreaseBalances,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },
];
